import React from "react";
import "./App.css";

/* ----------------  MENU DATA  ---------------- */
/* Each section declares:
   • title:       string
   • variant:     "solid" | "outline" | "plain"  (background style)
   • alignment:   "left" | "right" | "full"      (grid placement)
   • tagline?:    optional subtitle string
   • items:       array of [name, description, price] */
const MENU = [
  {
    title:     "Appetizers",
    variant:   "solid",
    alignment: "left",
    tagline:   "Fresh, vibrant flavors to start your meal",
    items: [
      [
        "House Hummus",
        "Smooth and creamy house-made hummus with a drizzle of olive oil, a sprinkle of sumac, and served with warm pita.",
        "7",
      ],
      [
        "Smoky Baba Ghanoush",
        "Smoky roasted eggplant blended with tahini, garlic, and lemon. Served with pita.",
        "7",
      ],
      [
        "Stuffed Grape Leaves",
        "Hand-rolled grape leaves stuffed with seasoned rice and a touch of pomegranate molasses.",
        "7",
      ],
      [
        "Tabbouleh",
        "A fresh mix of parsley, tomatoes, and cracked wheat tossed in lemon and olive oil.",
        "7",
      ],
    ],
  },

      {
    title:     "Shawarma & Kebab Platters",
    variant:   "plain",
    alignment: "left",
    tagline:
      "Hearty and satisfying, served with salad, pickles, hummus, garlic sauce, and your choice of rice or vegetables.",
    items: [
      [
        "Chicken Shawarma",
        "Juicy, flame-roasted chicken, marinated in aromatic spices for a rich taste.",
        "20",
      ],
      [
        "Beef Shawarma",
        "Boldly spiced, slow-roasted beef, cooked to tender perfection with deep, savory flavors.",
        "23",
      ],
      [
        "Mixed Shawarma",
        "A delicious blend of beef and chicken.",
        "23",
      ],
      [
        "Chicken Souvlaki",
        "Greek-style grilled chicken, infused with lemon, garlic, and herbs.",
        "23",
      ],
      [
        "Chicken Kebab",
        "Flame-grilled chicken kebabs, marinated in saffron and house spices.",
        "23",
      ],
      [
        "Steak Shish Kebab",
        "Sliced tender steak, marinated and grilled to perfection.",
        "30",
      ],
    ],
  },

      {
    title:     "Party Platters",
    variant:   "solid",
    alignment: "left",
    items: [
      [
        "Four People",
        "Four Shawarma platters with a side of Turkish Dolma and choice of salad.",
        "90",
      ],
      [
        "Six People",
        "Two Shawarma platters, two Chicken Shish Kababs, and two Beef Shish Kababs with a side of hummus, dolma, and your choice of salad.",
        "165",
      ],
      [
        "Ten to Twelve People",
        "Four Shawarma platters, two Chicken Shish Kababs, two Chicken Souvlaki skewers, two Beef Shish Kababs, with a side of two dolma servings, hummus, baba ghanoush, and two salads of your choice.",
        "260",
      ],
    ],
  },

    
  {
    title:     "Pita Wraps",
    variant:   "outline",
    alignment: "right",
    tagline:
      "Handheld favorites, freshly made to order. Packed with flavor and wrapped in a toasted pita.",
    items: [
      [
        "Chicken Shawarma Wrap",
        "Tender, spiced chicken, flame-roasted and wrapped in warm pita with crisp veggies and your choice of sauce.",
        "9 / 15",
      ],
      [
        "Beef Shawarma Wrap",
        "Boldly spiced, slow-roasted beef wrapped in fresh pita with crisp veggies and your choice of sauce.",
        "10 / 17",
      ],
      [
        "Mixed Shawarma Wrap",
        "The best of both worlds—juicy beef and chicken, roasted to perfection.",
        "10 / 17",
      ],
      [
        "Chicken Souvlaki Wrap",
        "Greek-style marinated chicken, wrapped with hummus, tabbouleh, veggies, and your choice of sauce.",
        "17",
      ],
      [
        "Grilled Chicken Kebab Wrap",
        "Grilled chicken kebab, wrapped with hummus, tabbouleh, veggies, and your choice of sauce.",
        "17",
      ],
      [
        "Mediterranean Veggie Wrap",
        "A delicious mix of hummus and baba ghanoush, plus fresh veggies and sauce.",
        "7 / 11",
      ],
    ],
  },

  {
    title:     "Fresh Salads",
    variant:   "solid",
    alignment: "right",
    tagline:   "Light, crisp, and full of Mediterranean goodness",
    items: [
      [
        "Classic Greek Salad",
        "A fresh mix of lettuce, tomatoes, cucumbers, red onion, olives, and feta.",
        "6 / 10",
      ],
      [
        "Seasonal Garden Salad",
        "Seasonal greens and crunchy veggies tossed in our house dressing.",
        "6 / 10",
      ],
      [
        "Add Chicken Shawarma",
        "Top any salad with our signature chicken shawarma.",
        "6 / 9",
      ],
      [
        "Add Chicken Kebab",
        "Top any salad with flame-grilled chicken kebab.",
        "11",
      ],
      [
        "Add Chicken Souvlaki",
        "Top any salad with Greek-style chicken souvlaki.",
        "11",
      ],
    ],
  },


  {
    title:     "Dessert",
    variant:   "solid",
    alignment: "right",
    tagline:
      "",
    items: [
      [
        "Baklava",
          "Layered pastry dessert made of filo pastry, filled with chopped nuts, and sweetened with syrup.",
        "2",
      ],
    ],
  },
      

    {
	  title:     "Sides / Extras",
    variant:   "outline",
    alignment: "full",
    items: [
      [
        "House-Made Sauces – Garlic, Tahini, Tzatziki Yogurt, Salad Dressing",
        "",
        "$2 | Large $3",
      ],
      [
        "Pickles or Pickled Turnips – Tangy, crunchy, and the perfect bite",
        "",
        "$4",
      ],
    ],
  },



];

/* ----------------  MAIN APP  ---------------- */
export default function App() {
  return (
    <div className="sheet">
      {/* ===== logo ===== */}
      <header className="logo-area">
        {/* Replace with your actual logo image */}
        <img
          src="/saffronlogo.png"
          alt="Saffron Eatery Logo"
          className="logo-leaf"
        />
      </header>

      {/* ===== Meet The Owners ===== */}
      <section className="frame owners-block">
        <img
          className="owners-photo"
          src="/aboutusimage.png"
          alt="Mehran and Soheila – owners"
        />
	  <div className="owners-text">
        <article>
          <h2>Meet The Owners</h2>
          <p>
            Saffron Eatery is a beloved mom-and-pop spot, run by Mehran and
            Soheila, who pour their hearts into every dish. With a deep passion
            for Mediterranean cuisine and culture, they create flavorful,
            authentic meals that feel like home. Come by and experience the
            warmth and tradition of Saffron Eatery for yourself.
          </p>
        </article>
	      </div>
      </section>

      {/* ===== MENU (GRID LAYOUT) ===== */}
      <main className="menu">
        {MENU.map((section) => (
          <MenuSection key={section.title} {...section} />
        ))}
      </main>

      {/* ===== footer ===== */}

	    <footer>
		<h1>Place An Order With Us!</h1>
		<a href="tel:19059821106" className="phone">
		    (905) 982-1106
		</a>
		<a
		    href="https://instagram.com/saffroneatery"
		    target="_blank"
		    rel="noopener noreferrer"
		    className="instagram-link"
		>
		    @saffroneatery
		</a>
	
		<h2>151 Queen St, Port Perry, ON L9L 1B8</h2>
	    </footer>

    </div>
  );
}

/* ----------------  MENU SECTION COMPONENT  ---------------- */
function MenuSection({ title, tagline, items, variant, alignment }) {
  // Example className: "frame menu-box solid left" or "frame menu-box outline full"
  const classNames = `frame menu-box ${variant} ${alignment}`;

  return (
    <section className={classNames}>
	<h3 className="section-title">
	    {title.split(" ").map((word, i, arr) => (
		<span className="title-word" key={i}>
		    <span className="first-letter">{word.charAt(0)}</span>
		    {word.slice(1)}
		</span>
	    ))}
	</h3>
      {tagline && <p className="tagline">{tagline}</p>}

      <ul className="item-list">
        {items.map(([name, desc, price]) => (
          <li key={name} className="item">
            {/* Row 1: Name … Price */}
            <div className="item-simple">
              {name} … {price}
            </div>
            {/* Row 2: Description */}
            <div className="item-desc">{desc}</div>
          </li>
        ))}
      </ul>
    </section>
  );
}
